<template>
  <div>
    <el-dialog
      :title="$t('errorPayments.errorPaymentsForm.modal.title')"
      :visible.sync="errorPaymentsModalVisible"
      :close-on-click-modal="false"
      @open="errorPaymentsModalShow"
      @close="errorPaymentsModalHide"
      fullscreen
    >
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <div class="grid-error-container-modal">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :defaultColDef="defaultColDef"
              :columnDefs="errorPaymentsColumnDefs"
              :rowData="paymentErrors"
              :gridOptions="errorPaymentsGridOptions"
              @grid-ready="onPaymentErrorsGridReady"
              @first-data-rendered="onFirstPaymentErrorsDataRendered"
              @modelUpdated="onErrorPaymentsModelUpdated"
              @rowSelected="onErrorPaymentsRowSelected"
              @rowDoubleClicked="onErrorPaymentsRowDoubleClicked"
              @cellContextMenu="onPaymentErrorsRowRightClicked"
            ></ag-grid-vue>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" style="margin-top: 10px;">
        <el-col :span="24">
          <el-checkbox
            v-model="autoDistributeCheckbox"
            v-shortkey="{ F2: ['f2'] }"
            @shortkey.native="onShortKeyRouter"
          >
            {{ $t("errorPayments.errorPaymentsForm.autoDistribute") }}
          </el-checkbox>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentChangeBtn('edit')"
              :disabled="fixBtnDisabled"
              v-shortkey="{ Enter: ['enter'], F4: ['f4'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F4</span
              >{{ $t("common.buttons.fix") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentChangeBtn('del')"
              :disabled="removeBtnDisabled"
              v-shortkey="{ Del: ['del'], Minus: ['-'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">Del</span
              >{{ $t("common.buttons.remove") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentDistributeBtn"
              :disabled="distributeBtnDisabled"
              v-shortkey="{ F9: ['f9'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F9</span
              >{{ $t("common.buttons.distribute") }}</el-button
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="plain"
              size="small"
              @click="errorPaymentsModalVisible = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.close") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <Payment></Payment>
  </div>
</template>

<script>
import { sortSum, formatSum } from "@/helpers/reference";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import Payment from "@/components/Payment";
import { setGridView } from "@/helpers/grid";
import { dialogWidth } from "@/mixins/dialogWidth";

export default {
  name: "errorpayments",
  components: {
    AgGridVue,
    Payment
  },
  mixins: [dialogWidth],
  data() {
    return {
      errorPaymentsModalVisible: false,
      agGridlocaleText: null,
      errorPaymentsGridOptions: null,
      errorPaymentsGridApi: null,
      errorPaymentsColumnApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      errorPaymentsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.payment"),
          headerTooltip: this.$t("common.gridColumns.payment"),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeLong"),
              headerTooltip: this.$t("common.gridColumns.abcodeLong"),
              field: "abcode",
              tooltipField: "abcode"
            },
            {
              headerName: this.$t("common.gridColumns.error"),
              headerTooltip: this.$t("common.gridColumns.error"),
              field: "errorname",
              tooltipField: "errorname"
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.npack"),
              headerTooltip: this.$t("common.gridColumns.npack"),
              field: "npack",
              tooltipField: "npack"
            },
            {
              headerName: this.$t("common.gridColumns.sumorig"),
              headerTooltip: this.$t("common.gridColumns.sumorig"),
              field: "sumorig",
              tooltipField: "sumorig",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.currencyname"),
              headerTooltip: this.$t("common.gridColumns.currencyname"),
              field: "currencyname",
              tooltipField: "currencyname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.bank"),
              headerTooltip: this.$t("common.gridColumns.bank"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.payname"),
              headerTooltip: this.$t("common.gridColumns.payname"),
              field: "payname",
              tooltipField: "payname"
            },
            {
              headerName: this.$t("common.gridColumns.mess"),
              headerTooltip: this.$t("common.gridColumns.mess"),
              field: "prim",
              tooltipField: "prim"
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.validity"),
          headerTooltip: this.$t("common.gridColumns.validity"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebegin"),
              headerTooltip: this.$t("common.gridColumns.datebegin"),
              field: "datebegin",
              tooltipField: "datebegin",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.dateend"),
              headerTooltip: this.$t("common.gridColumns.dateend"),
              field: "dateend",
              tooltipField: "dateend",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.makingEntry"),
          headerTooltip: this.$t("common.gridColumns.makingEntry"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebeginfact"),
              headerTooltip: this.$t("common.gridColumns.datebeginfact"),
              field: "datebeginfact",
              tooltipField: "datebeginfact",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.username"),
              headerTooltip: this.$t("common.gridColumns.username"),
              field: "username",
              tooltipField: "username"
            }
          ]
        }
      ],
      currentErrorPaymentRowSelected: null,
      fixBtnDisabled: true,
      removeBtnDisabled: true,
      distributeBtnDisabled: true,
      autoDistributeCheckbox: false,
      paymentErrorsLastRow: null
    };
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.errorPaymentsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-state-delivered": params => params.data.coderr === "0"
      }
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapGetters([
      "errorPaymentsModal",
      "paymentErrors",
      "errorPaymentsSearchParams",
      "paymentPostingError",
      "paymentRefreshErrors"
    ])
  },
  watch: {
    errorPaymentsModal: function(value) {
      this.errorPaymentsModalVisible = value;
    },
    errorPaymentsModalVisible: function(value) {
      this.setErrorPaymentsModal(value);
    },
    paymentPostingError: function(value) {
      if (value) {
        this.$alert(value.message, "", {
          confirmButtonText: "OK",
          type: value.type,
          callback: () => {
            this.getErrorPayments();
          }
        });
      }
    },
    paymentRefreshErrors: function(value) {
      if (value) {
        this.$store.commit("setPaymentRefreshErrors", null);

        if (
          value.type === "edit" &&
          value.statusPay === "0" &&
          this.autoDistributeCheckbox
        ) {
          const payid = value.newPayId;
          this.clearPaymentPostingError();
          this.$store.dispatch("paymentPostingError", { payid });
        } else {
          this.paymentErrorsLastRow = value.newPayId;
          this.getErrorPayments();
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      "setErrorPaymentsModal",
      "setGridContextMenuModal",
      "setGridContextMenuKey",
      "setGridContextMenuEvent",
      "setPaymentData",
      "setPaymentModal",
      "setPaymentRefreshErrors",
      "clearPaymentErrors",
      "clearErrorPaymentsSearchParams",
      "clearPaymentPostingError"
    ]),
    ...mapActions(["getPaymentErrors"]), // , "paymentPostingError"
    errorPaymentsModalShow() {
      this.getErrorPayments();
    },
    errorPaymentsModalHide() {
      this.clearPaymentErrors();
      this.clearErrorPaymentsSearchParams();
    },
    getErrorPayments() {
      if (this.errorPaymentsGridOptions.api) {
        this.errorPaymentsGridOptions.api.setRowData([]);
        this.errorPaymentsGridOptions.api.showLoadingOverlay();
      }

      const perror = "1";
      const {
        abcode,
        abcodeTypeSearch,
        sumPayBegin,
        sumPayEnd,
        sumPayTypeSearch,
        dateBankBegin,
        dateBankEnd,
        dateBankTypeSearch,
        datePayBegin,
        datePayEnd,
        datePayTypeSearch,
        dateChangeBegin,
        dateChangeEnd,
        dateChangeTypeSearch,
        errorType,
        npack,
        datePayFrom,
        datePayTo,
        kindpay,
        codefirme,
        note,
        noteTypeSearch
      } = this.errorPaymentsSearchParams;

      this.getPaymentErrors({
        perror,
        abcode,
        abcodeTypeSearch,
        sumPayBegin: sumPayBegin || 0,
        sumPayEnd: sumPayEnd || 0,
        sumPayTypeSearch,
        dateBankBegin: dateBankBegin || "",
        dateBankEnd: dateBankEnd || "",
        dateBankTypeSearch,
        datePayBegin: datePayBegin || "",
        datePayEnd: datePayEnd || "",
        datePayTypeSearch,
        dateChangeBegin: dateChangeBegin || "",
        dateChangeEnd: dateChangeEnd || "",
        dateChangeTypeSearch,
        errorType: errorType || "",
        npack: npack || "",
        datePayFrom: datePayFrom || "",
        datePayTo: datePayTo || "",
        kindpay: kindpay || "",
        codefirme: codefirme || "",
        note,
        noteTypeSearch
      });
    },
    onPaymentErrorsGridReady(params) {
      this.errorPaymentsGridApi = params.api;
      this.errorPaymentsColumnApi = params.columnApi;
    },
    onFirstPaymentErrorsDataRendered(event) {
      setGridView("wb-errorpayments-grid-paymenterrors", event, "full");
    },
    onPaymentErrorsRowRightClicked(event) {
      this.setGridContextMenuKey("wb-errorpayments-grid-paymenterrors");
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onErrorPaymentsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      if (rowCount === 0) {
        this.fixBtnDisabled = true;
        this.removeBtnDisabled = true;
        this.distributeBtnDisabled = true;
      } else {
        this.fixBtnDisabled = false;
        this.removeBtnDisabled = false;
        this.distributeBtnDisabled = true;

        params.api.forEachNode(node => {
          if (node.data.payid === this.paymentErrorsLastRow) {
            node.setSelected(true);
            params.api.ensureIndexVisible(node.rowIndex);
          } else {
            node.rowIndex ? 0 : node.setSelected(true);
          }
        });
      }
    },
    onErrorPaymentsRowSelected(params) {
      if (params.node.selected) {
        this.currentErrorPaymentRowSelected = params.node.data;

        this.distributeBtnDisabled =
          this.currentErrorPaymentRowSelected.coderr !== "0" ? true : false;
      }
    },
    onErrorPaymentsRowDoubleClicked() {
      this.onClickErrorPaymentChangeBtn("edit");
    },
    onClickErrorPaymentChangeBtn(state) {
      const { payid } = this.currentErrorPaymentRowSelected;

      const payload = {
        state,
        npack: "",
        payid,
        date: "",
        sumPay: 0,
        kindpay: "",
        countpay: 0,
        note: ""
      };
      this.setPaymentData(payload);
      this.setPaymentModal(true);
    },
    onClickErrorPaymentDistributeBtn() {
      const { payid } = this.currentErrorPaymentRowSelected;

      this.clearPaymentPostingError();
      this.$store.dispatch("paymentPostingError", { payid }); // !!! конфликт имен экшена с геттером
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        // ErrorPayments: F2 Автоматически разнести платеж после изменения
        case "F2":
          if (this.errorPaymentsModal && !this.paymentModal) {
            this.autoDistributeCheckbox = !this.autoDistributeCheckbox;
          }
          break;
        // ErrorPayments: F4 Исправить
        case "F4":
          if (
            !this.fixBtnDisabled &&
            this.errorPaymentsModal &&
            !this.paymentModal
          ) {
            this.onClickErrorPaymentChangeBtn("edit");
          }
          break;
        // ErrorPayments: F9 Разнести
        case "F9":
          if (
            !this.distributeBtnDisabled &&
            this.errorPaymentsModal &&
            !this.paymentModal
          ) {
            this.onClickErrorPaymentDistributeBtn();
          }
          break;
        // ErrorPayments: Del, "-" Удалить
        case "Del":
        case "Minus":
          if (
            !this.removeBtnDisabled &&
            this.errorPaymentsModal &&
            !this.paymentModal
          ) {
            this.onClickErrorPaymentChangeBtn("del");
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-error-container-modal {
  height: calc(100vh - 210px);
  overflow-y: auto;
}
</style>
